import { render, staticRenderFns } from "./EntityTabs.vue?vue&type=template&id=31fb13d3&scoped=true"
import script from "./EntityTabs.vue?vue&type=script&lang=js"
export * from "./EntityTabs.vue?vue&type=script&lang=js"
import style0 from "./EntityTabs.vue?vue&type=style&index=0&id=31fb13d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fb13d3",
  null
  
)

export default component.exports